import { clsx } from "@trydig/ui";
import InfoSvg from "~/public/icons/16px/Info.svg";
import styles from "./CartNotification.module.css";
export type CartNotificationTypes = "info" | "error";

export interface CartNotificationProps {
	type: CartNotificationTypes;
	message: React.JSX.Element | string;
	show?: boolean;
	reset?: () => void;
}

export const CartNotification = ({ type, message, show = true, reset }: CartNotificationProps) => {
	if (!show) return null;
	return (
		<div className={clsx(styles["cart-notification"], styles[`cart-notification-${type}`])}>
			<span className={styles.icon}>
				<InfoSvg />
			</span>
			<p className={styles.message}>
				{message}{" "}
				{reset && (
					<button className={styles.resetButton} onClick={reset}>
						Prøv igjen
					</button>
				)}
			</p>
		</div>
	);
};
